import { render } from "./TournamentCategory.vue?vue&type=template&id=da0b0184"
import script from "./TournamentCategory.vue?vue&type=script&lang=js"
export * from "./TournamentCategory.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__